<div [className]="bannerClassName" role="status">
    @if (showIcon && !!bannerIcon) {
        <mat-icon class="banner-icon" [svgIcon]="bannerIcon"></mat-icon>
    }
    <ng-content></ng-content>
    @if (closable) {
        <mat-icon role="button" class="close-icon" svgIcon="close" (click)="onClose()"></mat-icon>
    }
</div>
